import React from 'react'
import {  TimePicker } from 'antd';
import dayjs from 'dayjs';

const Time = () => {
  return (
    <TimePicker placeholder='' width={"100%"} size="large" />
  )
}

export default Time